// extracted by mini-css-extract-plugin
module.exports = {"payFabricHostedForm":"PayFabricModal_payFabricHostedForm__1aKCq","payFabricLoading":"PayFabricModal_payFabricLoading__1jcZ8"};